<template>
  <div class="home-page">
    <div class="p-4 mb-4 bg-body-tertiary rounded-3 az-custom-back">
      <h1 class="display-5 fw-bold text-center">{{ t('welcome') }}</h1>
    </div>
    <MyDestructions
      v-if="isVortexStock"
      key="home-destructions"
      persist-key="destructions"
    />
    <div class="mb-4"></div>
    <MyStatusChange
      v-if="isVortexStock"
      key="home-status_change"
      persist-key="status_change"
    />
    <div class="mb-4"></div>

    <MyOrders
      v-if="showOrders || isAdmin"
      key="home-orders_my"
      filter="my"
      persist-key="orders_my"
    />
    <div class="mb-4"></div>
    <MyOrders
      v-if="showOrders || isAdmin"
      key="home-orders_group"
      filter="group"
      persist-key="orders_group"
    />
    <div class="mb-4"></div>
    <MyActivities
      v-if="showActivities"
      key="home-activities"
      filter="group"
      persist-key="activities"
    />
  </div>
</template>

<script setup>
import MyOrders from '@/views/orders/myOrders.vue'
import MyActivities from '@/views/activities/myActivities.vue'
import MyDestructions from '@/views/destructions/myDestructions.vue'
import MyStatusChange from '@/views/stock/myStatusChange.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/stores/user.js'

const { t } = useI18n()
const userStore = useUserStore()
const isVortexStock = computed(() => userStore.can(['vortex_stock']))
const isAdmin = computed(() => userStore.can(['sa']))
const showActivities = computed(() => userStore.can(['manager', 'supermanager']))
const showOrders = computed(
  () => userStore.can(['orders_view', 'orders_edit']) && !isVortexStock.value
)
</script>

<i18n>
{
  "ru": {
    "welcome": "Добро пожаловать в систему SOYKA:RTMS"
  },
  "en": {
    "welcome": "Welcome to the SOYKA:RTMS system"
  }
}
</i18n>
